import React, { memo, useCallback } from 'react';
import { Space, Switch, Typography } from 'antd';

import { AISwitcherOptionsProps } from '../service/ai.interface';
import { useCreatePrompt } from '../hooks/useCreatePrompt';
import { useAiProfile } from '../hooks/useAIProfile';

const { Text } = Typography;

export const AISwitcher = memo(({ name, type }: AISwitcherOptionsProps) => {
    const { submit: submitSwitch, isLoading } = useCreatePrompt();
    const aiProfile = useAiProfile();

    const handleSwitchChange = useCallback(
        (checked: boolean) => {
            if (!aiProfile) return;

            void submitSwitch({
                ...aiProfile,
                ai_assistant_enable: checked,
            });
        },
        [aiProfile, submitSwitch]
    );

    return (
        <Space direction='vertical' size={[0, 8]}>
            <Space>
                <Text>{name}</Text>
            </Space>
            <Switch
                disabled={aiProfile.status.isLoading}
                loading={isLoading}
                id={type}
                value={aiProfile.ai_assistant_enable}
                onChange={handleSwitchChange}
            />
        </Space>
    );
});
